export enum InventoryItemActionSource {
  Rule = "rule",
  Manual = "manual",
}
